import extractApiData from 'Helpers/extractApiData'
import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'Helpers/encodeParams'

const endpoints = (baseURL => {
  return {
    /**
     * @deprecated
     */
    existSendingRunningMessage: idMessage =>
      `${baseURL}/api/email/message/${encodeURIComponent(
        idMessage
      )}/sending/running`,
    getRunningSending: `${baseURL}/api/sendings/running`,
    getReadySending: params =>
      `${baseURL}/api/sendings/ready?${encodeParams(params)}`,
    getStandBySending: `${baseURL}/api/sendings/standby`,
    deleteSending: idSending =>
      `${baseURL}/api/sending/${encodeURIComponent(idSending)}`,
    recoverSending: idSending =>
      `${baseURL}/api/sending/${encodeURIComponent(idSending)}/recover`,
    exchangeOrderReadySending: (id1, id2) =>
      `${baseURL}/api/exchange/${encodeURIComponent(
        id1
      )}/with/${encodeURIComponent(id2)}`,
    stopSending: idSending =>
      `${baseURL}/api/sending/${encodeURIComponent(idSending)}/stop`,
    stopSendings: `${baseURL}/api/sendings/stop`,
    setStandBySendingToReady: idSending =>
      `${baseURL}/api/sending/${encodeURIComponent(idSending)}/standby`,
    getEmailSendingDetails: idSending =>
      `${baseURL}/api/sending/${encodeURIComponent(idSending)}/details`,
    checkSendingProgress: idMessage =>
      `${baseURL}/api/message/${encodeURIComponent(idMessage)}/running`,
    getEmailMessages: (idList, params) =>
      `${baseURL}/api/list/${encodeURIComponent(
        idList
      )}/message/search?${encodeParams(params)}`,
    getFailedSendings: `${baseURL}/api/sendings/failed/check`,
    getSendingsLimits: `${baseURL}/api/sendings/limits`,
    checkCreateSending: idMessage =>
      `${baseURL}/api/message/${encodeURIComponent(idMessage)}/check`,
    getSenderStatus: `${baseURL}/api/sender/status`,
    registedSender: `${baseURL}/api/sender/register`,
    createInactiveSchedule: idMessage =>
      `${baseURL}/api/message/${encodeURIComponent(idMessage)}`,
    sendToRecipients: (idMessage, idList) =>
      `${baseURL}/api/transactional/message/${encodeURIComponent(
        idMessage
      )}/list/${encodeURIComponent(idList)}/recipients`,
    sendToGroup: (idMessage, idList, idGroup) =>
      `${baseURL}/api/transactional/message/${encodeURIComponent(
        idMessage
      )}/list/${encodeURIComponent(idList)}/group/${encodeURIComponent(
        idGroup
      )}/recipients`,
    existsFailedSending: `${baseURL}/api/check/failed/exist`,
    setNoDisturbConfig: idSending =>
      `${baseURL}/api/sending/${encodeURIComponent(idSending)}/nodisturbconfig`,
    getNoDisturbConfig: idSending =>
      `${baseURL}/api/sending/${encodeURIComponent(idSending)}/nodisturbconfig`,
    removeNoDisturbConfig: idSending =>
      `${baseURL}/api/sending/${encodeURIComponent(idSending)}/nodisturbconfig`,
    updateNoDisturbConfig: idSending =>
      `${baseURL}/api/sending/${encodeURIComponent(idSending)}/nodisturbconfig`,
    getBestPlanningDataAvailable: idList =>
      `${baseURL}/api/list/${encodeURIComponent(
        idList
      )}/sending/bestplanningdataavailable`,
    getSmartPlanningSuggestedDate: (idList, idSending) =>
      `${baseURL}/api/list/${encodeURIComponent(
        idList
      )}/sending/${encodeURIComponent(idSending)}/smartplanningsuggesteddate`
  }
})(process.env.BESENDGO_URL)

export const beSendGoApiGetBestPlanningDataAvailable = idList => {
  const url = endpoints.getBestPlanningDataAvailable(idList)
  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const beSendGoApiGetSmartPlanningSuggestedDate = (idList, idSending) => {
  const url = endpoints.getSmartPlanningSuggestedDate(idList, idSending)
  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

/**
 * @deprecated
 * @see beSendGoCheckSendingProgress
 */
export const beSendGoApiExistSendingRunningMessage = idMessage => {
  const url = endpoints.existSendingRunningMessage(idMessage)
  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const beSendGoGetRunningSending = () => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getRunningSending
  }).then(extractApiData)
}

/**
 * @description Retrieve the ready sending list.
 * @param {Object} params
 * @param {Array<number>} idLists
 * @param {Array<string>} statuses Available values : Scheduled, Ready
 * @param {string} dateFrom
 * @param {string} dateTo
 * @returns
 */
export const beSendGoGetReadySending = params => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getReadySending(params)
  }).then(extractApiData)
}

export const beSendGoGetStandBySending = () => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getStandBySending
  }).then(extractApiData)
}

export const beSendGoDeleteSending = idSending => {
  const url = endpoints.deleteSending(idSending)
  return apiWrapper({
    method: 'delete',
    url: url
  }).then(extractApiData)
}

export const beSendGoRecoverSending = idSending => {
  const url = endpoints.recoverSending(idSending)
  return apiWrapper({
    method: 'put',
    url: url
  }).then(extractApiData)
}

export const beSendGoExchangeOrderReadySending = (
  firstIdSending,
  secondIdSending
) => {
  const url = endpoints.exchangeOrderReadySending(
    firstIdSending,
    secondIdSending
  )
  return apiWrapper({
    method: 'put',
    url: url
  }).then(extractApiData)
}

export const beSendGoStopSending = idSending => {
  const url = endpoints.stopSending(idSending)
  return apiWrapper({
    method: 'put',
    url: url
  }).then(extractApiData)
}

export const beSendGoStopSendings = sendingsIdList => {
  const url = endpoints.stopSendings
  return apiWrapper({
    method: 'put',
    url: url,
    data: JSON.stringify(sendingsIdList)
  }).then(extractApiData)
}

/**
 *
 * @param {int} idSending
 * @param {Object} scheduleSendingItem
 * @param {string} scheduleSendingItem.StartDate
 * @param {string} scheduleSendingItem.TimeZoneInternalCode
 * @param {number} scheduleSendingItem.Source
 */
export const beSendGoSetStandBySendingToReady = (
  idSending,
  scheduleSendingItem
) => {
  const url = endpoints.setStandBySendingToReady(idSending)
  return apiWrapper({
    method: 'post',
    url: url,
    data: JSON.stringify(scheduleSendingItem)
  }).then(extractApiData)
}

export const beSendGoGetEmailSendingDetails = idSending => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getEmailSendingDetails(idSending)
  }).then(extractApiData)
}

export const beSendGoCheckSendingProgress = idMessage => {
  return apiWrapper({
    method: 'get',
    url: endpoints.checkSendingProgress(idMessage)
  }).then(extractApiData)
}

/**
 * @description Gets the email sending details
 * @param {number} idList
 * @param {Object} params
 * @param {number} params.pageNum
 * @param {number} params.pageSize
 * @param {boolean} params.orderAsc
 * @param {Object} data
 * @param {Array<string>} data.Origins [ Manual, AbTest, ContentCampaign, Triggers, One2Many, WsImport, SmtpPlus ] list of origins
 * @param {Array<number>} data.IdMessages list of messages
 * @param {Array<number>} data.IdTags
 * @param {number} data.SentThreshold
 * @param {string} data.SearchText
 * @param {boolean} data.SearchInBody
 * @param {string} data.DateFrom
 * @param {string} data.DateTo
 * @param {boolean} data.Completed
 * @param {boolean} data.Started
 * @param {Array<number>} data.GroupsId
 * @param {Array<number>} data.ExcludedGroupsId
 * @param {Array<number>} data.FiletersId
 *
 * @returns
 */
export const beSendGoGetEmailMessages = (idList, params, data) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getEmailMessages(idList, params),
    data: JSON.stringify(data)
  }).then(extractApiData)
}

export const beSendGoGetFailedSendings = params => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getFailedSendings,
    data: JSON.stringify(params)
  }).then(extractApiData)
}

export const beSendGoSendingsLimits = () => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getSendingsLimits
  }).then(extractApiData)
}

/**
 * @description Check if it is necessary to create an inactive schedule of a message or there is already one.
 * @param {number} idMessage
 * @returns {EmailSendingDetails} email sending details
 */
export const beSendGoCheckCreateSending = idMessage => {
  return apiWrapper({
    method: 'post',
    url: endpoints.checkCreateSending(idMessage)
  }).then(extractApiData)
}

/**
 * @typedef {Object} TrustedSenderStatusResponse
 * @property {('NotConfirmed'|'Confirmed'|'Blocked'|'DeliverOk'|'DeliverWarn'|'DeliverError'|'NoDeliver'|'DeliverIsp')} Status
 * @property {string} AuthDate datetime string
 *
 * @description Get a registered sender status. Mind that Trusted senders are bounded only to IdList = 0
 * @param {string} EmailAddress
 * @param {('CON'|'O2M')} ServiceType
 * @returns {TrustedSenderStatusResponse} Trusted sender status response
 */
export const beSendGetSenderStatus = (EmailAddress, ServiceType = 'CON') => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getSenderStatus,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({
      EmailAddress,
      ServiceType
    })
  }).then(({ data }) => data)
}

/**
 * @typedef {Object} TrustedSenderRegisterResponse
 * @property {boolean} Value
 *
 * @description Register a new sender for authorization. This will insert a new sender and send an email for confirmation. While not confirmed this method can be used to resend the confirmation email.
 * @param {string} EmailAddress
 * @param {('CON'|'O2M')} ServiceType
 * @param {number} IdList default 0
 * @returns {TrustedSenderRegisterResponse} Trusted sender status response
 */
export const beSendRegisterSender = (
  EmailAddress,
  ServiceType = 'CON',
  IdList = 0
) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.registedSender,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({
      EmailAddress,
      ServiceType,
      IdList
    })
  }).then(({ data }) => data)
}

export const beSendGoCreateInactiveSchedule = (idMessage, params) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.createInactiveSchedule(idMessage),
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(params)
  }).then(({ data }) => data)
}

export const beSendGoSendToRecipients = (idMessage, idList, data) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.sendToRecipients(idMessage, idList),
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(({ data }) => data)
}

export const beSendGoSendToGroup = (idMessage, idList, idGroup, data) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.sendToGroup(idMessage, idList, idGroup),
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(({ data }) => data)
}

export const beSendGoExistsFailedSending = idLists => {
  const data = JSON.stringify(idLists)

  return apiWrapper({
    method: 'post',
    url: endpoints.existsFailedSending,
    headers: {
      'Content-Type': 'application/json'
    },
    data: data
  }).then(({ data }) => data)
}

export const beSendGoSetNoDisturbConfig = (idSending, value) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.setNoDisturbConfig(idSending),
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(value)
  }).then(({ data }) => data)
}

export const beSendGoUpdateNoDisturbConfig = (idSending, value) => {
  return apiWrapper({
    method: 'put',
    url: endpoints.updateNoDisturbConfig(idSending),
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(value)
  }).then(({ data }) => data)
}

export const beSendGoGetNoDisturbConfig = idSending => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getNoDisturbConfig(idSending),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(({ data }) => data)
}

export const beSendGoRemoveNoDisturbConfig = idSending => {
  return apiWrapper({
    method: 'delete',
    url: endpoints.removeNoDisturbConfig(idSending),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(({ data }) => data)
}
export const TRUSTED_SENDER_STATUS_APPLY_OVVERIDE_DOMAIN = 'ApplyOverrideDomain'
export const TRUSTED_SENDER_STATUS_NOT_CONFIRMED = 'NotConfirmed'
export const TRUSTED_SENDER_STATUS_CONFIRMED = 'Confirmed'
export const TRUSTED_SENDER_STATUS_BLOCKED = 'Blocked'
export const TRUSTED_SENDER_STATUS_DELIVER_OK = 'DeliverOk'
export const TRUSTED_SENDER_STATUS_DELIVER_WARN = 'DeliverWarn'
export const TRUSTED_SENDER_STATUS_DELIVER_ERROR = 'DeliverError'
export const TRUSTED_SENDER_STATUS_DELIVER_ISP = 'DeliverIsp'
export const TRUSTED_SENDER_STATUS_NO_DELIVER = 'NoDeliver'

export const QUICKSEND_SEND_RESULT_SUCCESS = 'Ok'
export const QUICKSEND_SEND_RESULT_ERROR = 'Error'
export const QUICKSEND_SEND_RESULT_FORBIDDEN = 'Forbidden'
